import React, { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import { NAV_LINKS, CONTACT, LOGO } from "../mock";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-colors duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur shadow-sm" : "bg-white"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-[68px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img src={LOGO} alt="Auracrest Haven" className="h-12 md:h-14 w-auto object-contain" />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-[13px] font-medium tracking-wide text-neutral-700 hover:text-[#17a89b] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <a
            href={`tel:${CONTACT.phone}`}
            className="hidden sm:flex items-center gap-2 font-bold text-neutral-900"
          >
            <Phone className="w-4 h-4" />
            {CONTACT.phone}
          </a>
          <button
            className="lg:hidden text-neutral-800"
            onClick={() => setOpen((v) => !v)}
            aria-label="menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-neutral-100 px-5 py-4 flex flex-col gap-4">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-sm font-medium text-neutral-700 hover:text-[#17a89b]"
            >
              {l.label}
            </a>
          ))}
          <a href={`tel:${CONTACT.phone}`} className="flex items-center gap-2 font-bold text-neutral-900">
            <Phone className="w-4 h-4" /> {CONTACT.phone}
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
